'use es6';

import { replace } from 'DesignData/actions/History';
import { TAB_OPEN, CUSTOM_WIDGET_BUFFER_FETCH, CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_EDITING_GLOBAL_CONTENT } from 'DesignData/actions/ActionTypes';
import { createPath } from 'DesignData/helpers/routingHelper';
import { CUSTOM_WIDGET } from 'DesignData/enums/DesignAssetTypes';
import { getCustomWidgetId, getActiveRevisionId } from 'DesignData/selectors/app';
import { getIsEditingGlobalContent } from 'DesignData/selectors/customWidgetEditorOptions';
import { makeGetCustomWidgetBuffer } from 'DesignData/selectors/customWidgetBuffers';
import { getPathname } from 'DesignData/lib/routing';
import { getHasGlobalContentEditorAccess } from 'DesignData/selectors/auth';
import { setIsEditingGlobalContent } from 'DesignData/actions/CustomWidgetEditorOptions';
const REVISIONS_ROUTE = 'revisions';
const GLOBAL_CONTENT_ROUTE = 'global-content';
const getCustomWidgetBuffer = makeGetCustomWidgetBuffer();
export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  const state = getState();
  const activeCustomWidgetId = getCustomWidgetId(state);
  const customWidgetId = result.customWidgetId || result.tab && result.tab.id;

  if (!activeCustomWidgetId || activeCustomWidgetId !== customWidgetId) {
    return result;
  }

  const currentPathname = getPathname();
  const isGlobalContentUrl = !!currentPathname.match(GLOBAL_CONTENT_ROUTE);
  const isEditingGlobalContent = getIsEditingGlobalContent(state, {
    customWidgetId
  });
  let modulePathname = createPath(CUSTOM_WIDGET, customWidgetId);
  const isOnRevisions = !!currentPathname.match(REVISIONS_ROUTE);

  if (isOnRevisions) {
    const revisionId = getActiveRevisionId(state);
    const revisionIdPath = revisionId !== undefined ? `/${revisionId}` : '';
    const revisionsPath = `revisions${revisionIdPath}`;
    modulePathname = `${modulePathname}/${revisionsPath}`;
  } //  Push


  let pathname;

  switch (result.type) {
    case CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_EDITING_GLOBAL_CONTENT:
      {
        if (result.isEditingGlobalContent) {
          pathname = `${modulePathname}/${GLOBAL_CONTENT_ROUTE}`;
        } else {
          pathname = modulePathname;
        }

        break;
      }

    case TAB_OPEN:
      {
        const customWidget = getCustomWidgetBuffer(state, {
          customWidgetId
        });

        if (customWidget && customWidget.global && isEditingGlobalContent && !isGlobalContentUrl) {
          pathname = `${modulePathname}/${GLOBAL_CONTENT_ROUTE}`;
        }

        break;
      }

    case CUSTOM_WIDGET_BUFFER_FETCH:
      {
        const {
          customWidget
        } = result;
        const hasGlobalContentEditorAccess = getHasGlobalContentEditorAccess(state);

        if (customWidget && isGlobalContentUrl) {
          if (!customWidget.global || hasGlobalContentEditorAccess) {
            pathname = modulePathname;
          } else if (!isEditingGlobalContent) {
            dispatch(setIsEditingGlobalContent(customWidgetId, true));
          }
        }

        break;
      }

    default:
      break;
  }

  if (pathname) {
    dispatch(replace({
      pathname
    }));
  }

  return result;
});